<template>
  <div class="bookmarks" :style="{'left':(slide ? '0px': '-230px')}">
      <div class="fixbox">
        <div class="fixtop" :class="[activeNav==-1?'active':'']" @click="linkToStable"><i class="el-icon-star-on"></i><span>{{ $t("bookmarks.stableName")}}</span></div>
        <ul class="marklist">
            <h1>{{ $t("bookmarks.usual") }}</h1>
            <li v-for="(item,index) in collect" @click="linkTo(item,index)" :key="item.id" :class="[index == activeNav ? 'active' : '']">
                <div class="flex">
                    <i :class="['iconfont',item.iconName]"></i>
                    <span class="mdName" v-if="$i18n.locale === 'zh'">{{item.moduleName}}</span>
                    <span class="mdName" v-if="$i18n.locale === 'en'">{{item.moduleEnName}}</span>
                </div>
                <div class="markicon">
                    <i @click.stop="uncollect(item,index)" class="iconfont icon-collection hover" @mouseenter="listhover3" @mouseleave="listhover4">
                        <div class="tooltip">
                            <span>{{ $t("bookmarks.collectTip2")}}</span>
                            <div class="arrow"></div>
                        </div>
                    </i>
                </div>
            </li>
        </ul>
        <div class="fixbot" @click="stable">
            <span v-show="!isStable" class="iconfont">&#58885;</span>
            <span v-show="isStable" class="iconfont">&#58886;</span>
        </div>
      </div>
  </div>
</template>
<script>
import { Mixins } from '@/config/mixins/mixins'
import { mapGetters, mapMutations } from 'vuex'
import across from "@/config/components/across.js"
import { $http } from '@/config/api/axios'
export default {
    name:'Bookmarks',
    mixins:[Mixins],
    props:{
        slide:Boolean,
        navPath:Array,
    },
    computed:{
        ...mapGetters('Home', [
            'navStable',
            'collect',
            'activeNav',
        ])
    },
    data(){
        return{
            isStable:false,
            clickRepeat:true
        }
    },
    methods:{
        ...mapMutations('Home', [
            'SET_NAV_STABLE',
            'SET_ACTIVE_NAV',
        ]),
        stable(){
            this.isStable = !this.isStable;
            this.SET_NAV_STABLE(this.isStable)
        },
        linkTo(routeObj,index){
            this.SET_ACTIVE_NAV(index)
            this.$emit('pathPush',routeObj);
        },
        linkToStable(){
            this.SET_ACTIVE_NAV(-1)
            this.$emit('pathPush',{path:'controller',moduleName:'控制台',moduleEnName:'Controller'})
        },
        uncollect(routeObj,index){
            if(this.clickRepeat){
                this.clickRepeat = false;
                $http("post", "/collectModule/isCollectModule",{id:routeObj.id,isCollect:'0'})
                .then((res)=>{
                    if(res.status === 'SUCCESS'){
                        let uncollIndex = -2
                        routeObj.collect = false;
                        this.collect.splice(index,1);
                        this.collect.forEach((item,acidx) => {
                            if(this.$route.path === `/${this.$root.$lang}/${item.path}`){
                                uncollIndex = acidx
                            }
                        });
                        this.SET_ACTIVE_NAV(uncollIndex)
                        this.msgsuccess(this.$t("featurelist.tip3"))
                        this.clickRepeat = true;
                    }else{
                        this.clickRepeat = true;
                        this.msgerror(this.$t("featurelist.tip4"))
                    }
                })
            }
        },
        listhover3(e){
            let tooltip = e.target.firstElementChild;
            tooltip.style.display = 'block';
        },
        listhover4(e){
            let tooltip = e.target.firstElementChild;
            tooltip.style.display = 'none';
        },
    },
}
</script>

<style lang="less" scoped>
.bookmarks{
    position: absolute;
    z-index: 8100;
    top: 0;
    left: -230px;
    min-width: 200px;
    height: 100%;
    background: #fff;
    border-radius: 0px 5px 5px 0px;
    box-shadow: 0px 0px 5px rgba(68, 48, 96, 0.2);
    transition: all .4s;
    .fixbox{
        display: flex;
        flex-direction: column;
        height: 100%;
        color: #404042;
        .fixtop{
            padding: 10px 15px;
            span{
                margin-left: 5px;
            }
            &.active{
                color: #4980d7;
            }
            &:hover{
                background:#e3ebff;
            }
        }
        .fixbot{
            margin-top: auto;
            padding: 10px 15px;
        }
        i{
            font-size: 15px;
        }
        h1{
            font-size: 14px;
            font-weight: normal;
            padding: 10px 15px;
        }
        .marklist{
            height: calc(100% - 80px);
            overflow-y: auto;
            li{
                display: flex;
                padding: 10px 15px;
                .mdName{
                    // vertical-align: 2px;
                    margin-left: 5px;
                    cursor: default;
                    width: 130px;
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                &.active{
                    color: #4980d7;
                }
                &:hover{
                    background:#e3ebff;
                }
                .markicon{
                    margin-left: auto;
                    .iconfont{
                        font-size: 16px;
                        cursor: pointer;
                    }
                    .hover{
                        position: relative;
                        .tooltip{
                            position: absolute;
                            left: -11px;
                            top: -34px;
                            background: #303133;
                            color: #fff;
                            min-width: 40px;
                            padding: 5px;
                            font-size: 12px;
                            border-radius: 4px;
                            text-align: center;
                            cursor: initial;
                            display: none;
                            div{
                                font-size: 12px;
                            }
                            .arrow{
                                position: absolute;
                                display: block;
                                width: 0;
                                height: 0;
                                border-color: transparent;
                                border-style:  solid;
                                border-width:6px;
                                bottom: -6px;
                                border-top-color:#303133;
                                border-bottom-width: 0;
                                left: 13px;
                            }
                            &:hover{
                                background: red;
                                display: none !important;
                            }
                        }
                    }
                }
            }
            &::-webkit-scrollbar{
                width: 4px;
            }
            &::-webkit-scrollbar-thumb{
                border-radius: 10px;
                box-shadow: inset 0 0 5px rgba(38, 38, 38, 0.2);
                background: rgba(38, 38, 38, 0.2);
            }
            &::-webkit-scrollbar-track{
                box-shadow: inset 0 0 5px rgba(38, 38, 38, 0.1);
                border-radius: 0;
                background: rgba(38, 38, 38, 0.1);
            }
        }
    }
    .flex{
        display: flex;
    }
}
.en-US{
    .bookmarks .fixbox span{
        vertical-align: 0px;
    }
    .bookmarks .fixbox i{
        font-size: 14px;
    }
    .bookmarks .fixbox .marklist li{
        padding: 0px 15px;
        line-height: 34px;
    }
    .bookmarks .fixbox .marklist li .markicon .hover .tooltip{
        padding: 0;
        top: -36px;
        line-height: 30px;
    }
}
.theme2{
    .bookmarks{
        .fixbox{
            .fixtop:hover{
                background: #6a6d7c;
                color: #fff;
            }
        }
    }
}
</style>